export default () => {
  return {
    isSidebarOpen: false,
    selectedTimezone: '',
    showStudioRightPanel: true,
  };
};
